import { render, staticRenderFns } from "./ExternalAppRedirect.vue?vue&type=template&id=45c30090&scoped=true"
import script from "./ExternalAppRedirect.vue?vue&type=script&lang=ts"
export * from "./ExternalAppRedirect.vue?vue&type=script&lang=ts"
import style0 from "./ExternalAppRedirect.vue?vue&type=style&index=0&id=45c30090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c30090",
  null
  
)

export default component.exports